import { Divider, Typography } from 'antd';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { buildPlaceholderCode } from './buildPlaceholderCode.ts';
import { type PlaceholderReference } from './types.ts';

export function PlaceholderCodePreview({
  selectedField,
}: {
  selectedField: PlaceholderReference;
}) {
  const values = useWatch<Record<string, string>>();
  const codePreview = useMemo(() => {
    return buildPlaceholderCode(selectedField, values ?? {}, true);
  }, [selectedField, values]);

  return (
    <>
      <Divider orientation="left">Anteprima</Divider>
      <Typography.Text code copyable>
        {codePreview}
      </Typography.Text>
    </>
  );
}
